import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const QuizCard = () => {
  const QUIZ_URL = "https://quiz.unipet.online/";
  const WPP_URL = "http://wa.me/5532999857587";

  return (
    <motion.div 
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.2, duration: 0.8 }}
      className="mt-12 relative group"
    >
      {/* Decorative Glow */}
      <div className="absolute -inset-1 bg-gradient-to-r from-amber-500/20 to-stone-500/20 rounded-[2.5rem] blur opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
      
      <div className="relative bg-white border border-stone-200 rounded-[2.5rem] p-8 sm:p-10 shadow-xl overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute top-0 right-0 p-4 opacity-[0.03] pointer-events-none">
          <SafeIcon name="Search" className="w-32 h-32 rotate-12" />
        </div>

        <div className="flex flex-col items-center text-center relative z-10">
          <div className="inline-flex items-center gap-2 mb-6 px-4 py-1.5 rounded-full bg-amber-50 border border-amber-100">
            <SafeIcon name="Sparkles" className="w-4 h-4 text-amber-600" />
            <span className="text-[10px] font-bold uppercase tracking-widest text-amber-800">Recomendação Inteligente</span>
          </div>

          <h2 className="font-serif text-3xl font-bold text-stone-900 mb-4">
            Qual o serviço ideal <br className="hidden sm:block" /> para seu Pet hoje?
          </h2>
          
          <p className="text-stone-600 mb-8 max-w-md mx-auto font-medium">
            Responda 4 perguntas rápidas para descobrir o pacote perfeito, valores estimados e tempo de sessão.
          </p>

          <div className="flex flex-col w-full gap-4">
            <a 
              href={QUIZ_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group/btn relative bg-stone-900 text-white px-8 py-5 rounded-2xl font-bold uppercase tracking-[0.2em] text-xs hover:bg-stone-800 transition-all shadow-lg flex items-center justify-center gap-3 overflow-hidden"
            >
              <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/10 to-transparent group-hover/btn:animate-[shimmer_1.5s_infinite]" />
              Iniciar Quiz de Agendamento
              <SafeIcon name="ArrowRight" className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
            </a>

            <div className="pt-6 border-t border-stone-100 mt-2">
              <p className="text-stone-500 text-sm italic mb-4">
                <span className="text-amber-700 font-bold">Importante:</span> Para aplicar seu cupom de 15%, você deve apresentar o resultado do quiz para nossa equipe no WhatsApp.
              </p>
              
              <a 
                href={WPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-stone-900 font-bold text-[10px] uppercase tracking-[0.2em] flex items-center justify-center gap-2 hover:text-amber-800 transition-colors"
              >
                Falar com consultor agora
                <SafeIcon name="MessageCircle" className="w-3 h-3" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes shimmer {
          100% { transform: translateX(100%); }
        }
      `}} />
    </motion.div>
  );
};

export default QuizCard;